import { Box, Typography, useTheme } from "@mui/material";

type FeatureCardProps = {
  title: string;
  description: string;
  image?: string;
  icon?: JSX.Element;
};

const FeatureCard = ({ title, description, image, icon }: FeatureCardProps) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Box
      textAlign="center"
      data-aos="fade-up"
      sx={{
        maxWidth: 280,
        mx: "auto",
        px: 2,
        transition: "transform 0.3s ease",
        "&:hover": {
          transform: "translateY(-4px)",
        },
      }}
    >
      {/* Image or Icon */}
      {image ? (
        <Box
          component="img"
          src={image}
          alt={title}
          sx={{
            width: "100%",
            aspectRatio: "4 / 3",
            borderRadius: "16px",
            objectFit: "cover",
            boxShadow: isDark
              ? "0 10px 30px rgba(0,0,0,0.3)"
              : "0 8px 24px rgba(0,0,0,0.08)",
            border: `1px solid ${isDark ? "#444" : "#e0e0e0"}`,
            mb: 2,
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
            "&:hover": {
              transform: "scale(1.03)",
              boxShadow: isDark
                ? "0 14px 36px rgba(255,255,255,0.1)"
                : "0 16px 32px rgba(0,0,0,0.12)",
            },
          }}
        />
      ) : (
        <Box sx={{ mb: 1 }}>{icon}</Box>
      )}

      {/* Title */}
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          fontFamily: '"Lexend", sans-serif',
          color: "#eee",
          mb: 1,
        }}
      >
        {title}
      </Typography>

      {/* Description */}
      <Typography
        variant="body2"
        sx={{
          fontFamily: '"Lexend", sans-serif',
          color: "grey",
        }}
      >
        {description}
      </Typography>
    </Box>
  );
};

export default FeatureCard;
